module.exports = __webpack_public_path__ + "img/Daily-Downloads-of-MongoDB-Related-Packages-768x658.b98bd6ab.png";